export const ProfessionalSalutationOptions = [
  {
    value: "Ar",
    label: "Ar",
  },
  {
    value: "ID",
    label: "ID",
  },
  {
    value: "PMC",
    label: "PMC",
  },
  {
    value: "Mr.",
    label: "Mr.",
  },
  {
    value: "Mrs.",
    label: "Mrs.",
  },
  {
    value: "Miss",
    label: "Miss",
  },
  {
    value: "Ms.",
    label: "Ms.",
  },
];

export const partnerOptions = [
  {
    value: "CEO",
    label: "CEO",
  },
  {
    value: "Founder",
    label: "Founder",
  },
  {
    value: "Co-Founder",
    label: "Co-Founder",
  },
  {
    value: "Partners",
    label: "Partners",
  },
  {
    value: "Principal Architect",
    label: "Principal Architect",
  },
  {
    value: "President",
    label: "President",
  },
  {
    value: "Owner",
    label: "Owner",
  },
  {
    value: "COO",
    label: "COO",
  },
  {
    value: "Managing Director (MD)",
    label: "Managing Director (MD)",
  },
  {
    value: "Chief Design Officer (CDO)",
    label: "Chief Design Officer (CDO)",
  },
];

export const fieldOptions = [
  ...partnerOptions,
  // Architectural and Interior Design Team:
  {
    value: "Junior Architect",
    label: "Junior Architect",
  },
  {
    value: "Senior Architect",
    label: "Senior Architect",
  },
  {
    value: "Intern Architect",
    label: "Intern Architect",
  },
  {
    value: "Project Architect",
    label: "Project Architect",
  },
  {
    value: "Design Architect",
    label: "Design Architect",
  },
  {
    value: "Technical Architect",
    label: "Technical Architect",
  },
  {
    value: "Landscape Designer",
    label: "Landscape Designer",
  },
  {
    value: "Interior Designer",
    label: "Interior Designer",
  },
  {
    value: "Junior Interior Designer",
    label: "Junior Interior Designer",
  },
  {
    value: "Senior Interior Designer",
    label: "Senior Interior Designer",
  },
  {
    value: "Furniture Designer",
    label: "Furniture Designer",
  },
  {
    value: "Interior Decorator",
    label: "Interior Decorator",
  },
  {
    value: "Urban Planner",
    label: "Urban Planner",
  },
  {
    value: "Architectural Drafter",
    label: "Architectural Drafter",
  },

  // Project Management and Coordination Team:
  {
    value: "HR and Administration",
    label: "HR and Administration",
  },
  {
    value: "Project Head",
    label: "Project Head",
  },
  {
    value: "Project Manager",
    label: "Project Manager",
  },
  {
    value: "Assistant Project Manager",
    label: "Assistant Project Manager",
  },
  {
    value: "Project Coordinator",
    label: "Project Coordinator",
  },
  {
    value: "Construction Manager",
    label: "Construction Manager",
  },
  {
    value: "Site Supervisor",
    label: "Site Supervisor",
  },
  {
    value: "Site Engineer",
    label: "Site Engineer",
  },

  // Engineering and Technical Support:
  {
    value: "Structural Engineer",
    label: "Structural Engineer",
  },
  {
    value: "MEP Engineer (Mechanical, Electrical, Plumbing)",
    label: "MEP Engineer (Mechanical, Electrical, Plumbing)",
  },
  {
    value: "Civil Engineer",
    label: "Civil Engineer",
  },
  {
    value: "BIM Specialist",
    label: "BIM Specialist",
  },
  {
    value: "Sustainability Consultant",
    label: "Sustainability Consultant",
  },
  {
    value: "LEED or Green Building Consultant",
    label: "LEED or Green Building Consultant",
  },

  // Visualization and Graphics Team:
  {
    value: "3D Visualizer",
    label: "3D Visualizer",
  },
  {
    value: "Rendering Specialist",
    label: "Rendering Specialist",
  },
  {
    value: "Graphic Designer",
    label: "Graphic Designer",
  },

  // Business Development and Client Relations:
  {
    value: "Client Relations Manager",
    label: "Client Relations Manager",
  },
  {
    value: "Business Development Manager",
    label: "Business Development Manager",
  },
  {
    value: "Marketing Specialist",
    label: "Marketing Specialist",
  },
  {
    value: "Sales Representative",
    label: "Sales Representative",
  },
  {
    value: "HR",
    label: "HR",
  },
  {
    value: "Administration",
    label: "Administration",
  },
  {
    value: "Social Media Manager",
    label: "Social Media Manager",
  },
  {
    value: "Head Of Department (Architecture)",
    label: "Head Of Department (Architecture)",
  },
  {
    value: "Head Of Department (Interior Design)",
    label: "Head Of Department (Interior Design)",
  },
  {
    value: "Head Of Department (Styling)",
    label: "Head Of Department (Styling)",
  },
  {
    value: "Head Of Department (Landscape)",
    label: "Head Of Department (Landscape)",
  },
  {
    value: "Team leader (Architecture)",
    label: "Team leader (Architecture)",
  },
  {
    value: "Team leader (Interior design)",
    label: "Team leader (Interior design)",
  },
  {
    value: "Team leader (styling)",
    label: "Team leader (styling)",
  },
  {
    value: "Team leader (Landscape)",
    label: "Team leader (Landscape)",
  },
  {
    value: "Associate Team Leader (Architecture)",
    label: "Associate Team Leader (Architecture)",
  },
  {
    value: "Associate Team leader (Interior design)",
    label: "Associate Team leader (Interior design)",
  },
  {
    value: "Associate Team leader (styling)",
    label: "Associate Team leader (styling)",
  },
  {
    value: "Associate Team leader (landscape)",
    label: "Associate Team leader (landscape)",
  },
];

export const LegendData = [
  {
    id: "1",
    colour: "#FFFFFF",
    label: "with driver, without driver & switch",
    category: null,
  },
  {
    id: "2",
    colour: "#E3BFC0",
    label: "RF Bluetooth",
    category: "RF_BLUETOOTH",
  },
  {
    id: "3",
    colour: "#BFD3E3",
    label: "Dali Dimmable",
    category: "DALI_DIMMABLE",
  },
  {
    id: "4",
    colour: "#BFE3C8",
    label: "Dali Tunable",
    category: "DALI_TUNABLE",
  },
  {
    id: "5",
    colour: "#CABFE3",
    label: "Phase cut",
    category: "PHASE_CUT",
  },
  // {
  //   id: "6",
  //   colour: "#E2E3BF",
  //   label: "Casambi",
  // },
];

export const MEDIA_ALLOWED_EXT_MAPPER = {
  "CP-PHOTO": ["jpg", "jpeg", "webp", "png"],
  "PI-PHOTO": ["jpg", "jpeg", "webp", "png"],
  "PC-LOGO": ["jpg", "jpeg", "webp", "png"],
  "PC-GSTC": ["jpg", "jpeg", "png", "pdf"],
  "PC-CCHEQUE": ["jpg", "jpeg", "png", "pdf"],
  "CP-LOGO": ["jpg", "jpeg", "webp", "png"],
  "CP-GSTC": ["jpg", "jpeg", "png", "pdf"],
  "CP-CCHEQUE": ["jpg", "jpeg", "png", "pdf"],
};

export const PAYMENT_MODES = [
  {
    value: "PG_ICICI",
    label: "PG ICICI",
  },
  {
    value: "BANK_TRANSFER",
    label: "BANK TRANSFER",
  },
  {
    value: "CASH",
    label: "CASH",
  },
  {
    value: "CHEQUE",
    label: "CHEQUE",
  },
  {
    value: "CREDIT_CARD",
    label: "CREDIT CARD",
  },
  {
    value: "GPAY",
    label: "GPAY",
  },
  {
    value: "PAYTM",
    label: "PAYTM",
  },
  {
    value: "BRAND_EMI",
    label: "BRAND EMI",
  },
  {
    value: "DEBIT_CARD",
    label: "DEBIT CARD",
  },
  {
    value: "BAJAJ_FINANCE",
    label: "BAJAJ FINANCE",
  },
  {
    value: "HDFC_BANK",
    label: "HDFC BANK",
  },
];

export const DELIVERY_OPTIONS = [
  "Get the products delivered together whenever available",
  "Deliver the items separately according to the timeline",
];

export const ORDER_STATUS = [
  {
    id: "DRAFT",
    name: "Draft",
  },
  {
    id: "PENDING",
    name: "Pending",
  },
  {
    id: "AWAITING_TIMELINE",
    name: "Awaiting Timeline",
  },
  {
    id: "PROCESSING",
    name: "Processing",
  },
  {
    id: "READY_FOR_DISPATCH",
    name: "Ready for Dispatch",
  },
  {
    id: "PARTIALLY_READY_FOR_DISPATCH",
    name: "Partially Ready for Dispatch",
  },
  {
    id: "DISPATCHED",
    name: "Dispatched",
  },
  {
    id: "PARTIALLY_DISPATCHED",
    name: "Partially Dispatched",
  },
  {
    id: "DELIVERED",
    name: "Delivered",
  },
  {
    id: "PARTIALLY_DELIVERED",
    name: "Partially Delivered",
  },
];

export const PAYMENT_STATUS = [
  { id: "UNPAID", name: "Unpaid" },
  { id: "PROCESSING", name: "Processing" },
  { id: "PARTIALLY_PAID", name: "Partially Paid" },
  { id: "PAID", name: "Paid" },
  { id: "REFUND", name: "Refund" },
];

export const defaultColors = [
  "#39D0BF",
  "#5766C1",
  "#FDAC2C",
  "#9962D0",
  "#EF4E83",
  "#7BCF3E",
  "#2490C2",
  "#EF7752",
  "#FCB740",
  "#5C5C5C",
];

export const PROJECT_STATUS = [
  { id: "true", name: "Public" },
  { id: "false", name: "Private" },
];

export const projectTypeOptions = [
  { value: "Residential", label: "Residential" },
  { value: "ResiCom", label: "ResiCom" },
  { value: "Commercial", label: "Commercial" },
  { value: "Office", label: "Office" },
  { value: "Retail", label: "Retail" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "F&B", label: "F&B" },
  { value: "Education", label: "Education" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Culture", label: "Culture" },
  { value: "Government", label: "Government" },
  { value: "Industrial", label: "Industrial" },
  { value: "Logistics", label: "Logistics" },
  { value: "Tech", label: "Tech" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Transport", label: "Transport" },
  { value: "Utilities", label: "Utilities" },
  { value: "Landscape", label: "Landscape" },
  { value: "Heritage", label: "Heritage" },
  { value: "Exhibition", label: "Exhibition" },
  { value: "Religious", label: "Religious" },
  { value: "Sports & Recreation", label: "Sports & Recreation" },
];
